var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "resource_card" }, [
    _c("div", { staticClass: "card_inner_wrap" }, [
      _c(
        "a",
        {
          staticClass: "card_image_link",
          class: { type_video: _vm.typeClass === "videos" },
          attrs: { href: _vm.model.url },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onClick.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            staticClass: "card_image",
            attrs: {
              src: _vm.thumbnailUrl,
              lazy: "",
              "data-static": _vm.thumbnailStaticUrl,
              alt: _vm.titleText,
              onerror: "this.src=this.dataset.static",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.resourceTags && _vm.resourceTags.length > 0
        ? _c(
            "div",
            { staticClass: "card_tags" },
            _vm._l(_vm.resourceTags, function (item, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "cart_tag_item",
                  attrs: { href: item.link },
                },
                [_vm._v(_vm._s(item.text))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card_text" }, [
        _c("h3", { staticClass: "card_mc_title" }, [
          _c(
            "a",
            {
              attrs: { href: _vm.model.url },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onClick.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.titleText))]
          ),
        ]),
        _vm._v(" "),
        _vm.authorUrl
          ? _c("a", { attrs: { href: _vm.authorUrl } }, [
              _c("i", { staticClass: "card_mc_author" }, [
                _vm._v("Author: " + _vm._s(_vm.author)),
              ]),
            ])
          : _vm.author
          ? _c("i", { staticClass: "card_mc_author" }, [
              _vm._v("Author: " + _vm._s(_vm.author)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card_mc_intro" }, [
          _vm._v("\n                " + _vm._s(_vm.summary) + "\n            "),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "read_more",
            attrs: { href: _vm.model.url },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onClick.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm.readMoreLabel))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }